import { render, staticRenderFns } from "./more-client-details-panel.vue?vue&type=template&id=34b087b1"
import script from "./more-client-details-panel.vue?vue&type=script&lang=js"
export * from "./more-client-details-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports